import apiClient from './client';
import { API_ROUTES } from './routes';

export interface Balance {
  available: number;
  pending: number;
  instantAvailable: number;
  currency: string;
  instantPayoutsAvailable: boolean;
  instantPayoutFeePercent: number;
  instantPayoutMinFee: number;
}

export interface InstantPayout {
  id: string;
  amount: number;
  currency: string;
  status: string;
  arrivalDate: number;
  fee: number;
}

export const payoutsApi = {
  async getBalance(): Promise<Balance> {
    const response = await apiClient.get<Balance>(API_ROUTES.CONNECT.BALANCE);
    return response.data;
  },

  async createInstantPayout(amount: number): Promise<InstantPayout> {
    const response = await apiClient.post<InstantPayout>(API_ROUTES.CONNECT.INSTANT_PAYOUTS, {
      amount,
    });
    return response.data;
  },
};
